import { Controller } from "@hotwired/stimulus"

// Controla una fila del formulario de orden de compra. Al elegir un SKU:
// - muestra su unidad de medida y su último precio (spans informativos),
// - autocompleta el input de precio con el último precio conocido (editable),
// - fija el IVA según la última compra del SKU (no editable: hidden + display),
// - dispara el recálculo de totales del formulario.
export default class extends Controller {
  static targets = ["measurement", "lastPrice", "price", "ivaInput", "ivaDisplay", "notes", "notesText"]

  showDetails(event) {
    const option = event.target.options[event.target.selectedIndex]
    if (!option) return
    const data = option.dataset

    this.updateNotes(data.notes || "")

    if (this.hasMeasurementTarget) this.measurementTarget.innerHTML = data.measurementFormat || ""
    if (this.hasLastPriceTarget) this.lastPriceTarget.innerHTML = data.lastPrice || ""

    // Autocompletar el precio con el último precio conocido (queda editable).
    if (this.hasPriceTarget && data.lastPriceInput) {
      this.priceTarget.value = data.lastPriceInput
    }

    // Fijar el IVA según la última compra. El valor se manda por el hidden field
    // y se refleja en el display de solo lectura.
    if (data.ivaRate) {
      if (this.hasIvaInputTarget) this.ivaInputTarget.value = data.ivaRate
      if (this.hasIvaDisplayTarget) this.ivaDisplayTarget.textContent = `${data.ivaRate}%`
    }

    // Recalcular subtotales/IVA/total del formulario (lo escucha el controlador
    // purchase-order vía el action input->purchase-order#calculateTotalPrice).
    if (this.hasPriceTarget) {
      this.priceTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  // Nota interna del SKU: se muestra solo si el SKU elegido tiene una. Es
  // público porque sku-refresh también la actualiza, al traer notas nuevas
  // sin que haya cambiado la selección.
  updateNotes(notes) {
    if (!this.hasNotesTarget) return

    if (this.hasNotesTextTarget) this.notesTextTarget.textContent = notes
    this.notesTarget.classList.toggle("d-none", notes === "")
  }
}
